import {
  axiosDelete,
  axiosGet,
  axiosPost,
  axiosPut,
} from '../plugins/axios.plugins';

const API_ENDPOINTS = {
  USER_TABELS_BASEURL: `${process.env.VUE_APP_DATA_API}/user-tables/`,
  CUSTOM_ITEM_BASEURL: `${process.env.VUE_APP_DATA_API}/custom-item`,
  SUM_CALCULATION_BASEURL: `${process.env.VUE_APP_TS_CALCULATION_API}/sum`,
  LOAD_FILE_BASEURL: `${process.env.VUE_APP_DATA_API}/files`,
  LOAD_PARSER_API: `${process.env.VUE_APP_LOAD_PARSER_API}/parse`,
  MERGE_CALCULATION_BASEURL: `${process.env.VUE_APP_TS_CALCULATION_API}/merge`,
  CALCULATE_METADATA_BASEURL: `${process.env.VUE_APP_TS_CALCULATION_API}/calculate-metadata`,
  SLP_URL: `${process.env.VUE_APP_SLP_GENERATOR_API}`,
  SLP_URL_V3: `${process.env.VUE_APP_SLP_GENERATOR_API_v3}`,
};

// options in below request is just for example purpose remove it afterwards
// options example
// {
//     params: { test: 'test' },
//     headers: { 'x-name': 'HEADER_VALUE' },
// }
export const getUserTabels = (
  tableName,
  params = '',
  customNotFoundRedirect = false
) => {
  return axiosGet(
    `${API_ENDPOINTS.USER_TABELS_BASEURL}${tableName}/items${params}`,
    customNotFoundRedirect ? { customNotFoundRedirect } : {}
  );
};

export const getSLPData = (params, options = {}) => {
  const endpoint = params.includes('slp-gas-profile')
    ? API_ENDPOINTS.SLP_URL_V3
    : API_ENDPOINTS.SLP_URL;
  return axiosGet(`${endpoint}${params}`, options);
};
export const sumLoadProfiles = (payload, params) => {
  return axiosPost(API_ENDPOINTS.SUM_CALCULATION_BASEURL, payload, params);
};

export const updateLoadFiles = (payload, params) => {
  return axiosPut(API_ENDPOINTS.LOAD_FILE_BASEURL, payload, params);
};

export const removeCustomItem = (payload) => {
  return axiosDelete(API_ENDPOINTS.CUSTOM_ITEM_BASEURL, payload);
};

export const parseLoadFile = (payload) => {
  return axiosPost(API_ENDPOINTS.LOAD_PARSER_API, payload);
};

export const mergeLoads = (payload) => {
  return axiosPost(API_ENDPOINTS.MERGE_CALCULATION_BASEURL, payload);
};

export const calculateMetaDataApi = (payload) => {
  return axiosPost(API_ENDPOINTS.CALCULATE_METADATA_BASEURL, payload);
};
